<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1021I5C/tc-custom/9781526749727.jpg?1707506116484" alt="This image is the cover for the book Last Years of the London Titan"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Years of the London Titan
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>The London Bendy Bus</i> memorializes the end of the Leyland Titan era in “a must for all London bus fans of the 1980s” (West Somerset Railway Association).</b><br/>  <br/> Already depleted by withdrawals in the London Buses Ltd era, the Leyland Titan fleet of T class was divided upon privatization between three new companies: London Central, Stagecoach East London and Stagecoach Selkent. Together with a host of smaller companies operating secondhand acquisitions, the Titans’ declining years between 1998 and 2003 are explored in this pictorial account that encompasses both standard day-to-day routes, emergency deployments and rail replacement services. Only small numbers remained to usher out the type altogether at the end of 2005, when step-entrance double-deckers as a whole were banished from the capital.<br/>  <br/> “[A] magnificent portrait of the time through an interesting collection of images.” —<i>Miniaturas JM</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matthew Wharmby
      </h2>
      
      <p class="authorDescription body article">Matthew Wharmby is an author, photographer and editor who specializes in London bus history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ff2bcc68